import React from 'react';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-wrapper">
          <div className="hero-content">
            <h2>Providing Professional Vehicles<br />& Expert Staff for Your Funeral&nbsp;Home&nbsp;Needs</h2>
            <a href="#contact" className="btn-primary">Contact Us 24/7</a>
          </div>
          <div className="hero-image">
            <img src="/car_picture.jpg" alt="Funeral Service Vehicle" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
